/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeEffects from "../../models/store/storeEffects";
import { IRiskPageOwnProps, IRiskPageStateProps, IRiskPageDispatchProps, RiskPage } from "../../components/risk/RiskPage/RiskPage";
import { ITypedOption } from "../../models/common/typedOption";
import { RiskThunkDispatch, getRiskPage } from "source/models/store/risk";

export function mapStateToProps(applicationState: IApplicationState, ownProps: IRiskPageOwnProps): IRiskPageStateProps {
    if (!applicationState || !applicationState.front) {
        return {
            appState: null,
            dataId: -1,
            riskPage: null,
            list: null,
            report: null
        };
    }
    const risk = applicationState.risk;
    return {
        appState: applicationState.session,
        dataId: risk.page.dataId,
        riskPage: risk.page.riskPage,
        list: risk.list,
        report: risk.report
    };
}

export function mapDispatchToProps(dispatch: RiskThunkDispatch): IRiskPageDispatchProps {
    return {
        onGetRiskPage: () => dispatch(getRiskPage()),
        onLogout: () => dispatch(storeEffects.logout()),
        onSetCulture: (culture: string) => dispatch(storeEffects.setCulture(culture)),
        onSaveUserParameters: (parameters: ITypedOption[]) => dispatch(storeEffects.saveUserParameters(parameters)),
        onRefreshSessionState: () => dispatch(storeEffects.refreshSessionState()),
    };
}

export default connect<IRiskPageStateProps, IRiskPageDispatchProps, IRiskPageOwnProps>(mapStateToProps, mapDispatchToProps)(RiskPage);